import { render, staticRenderFns } from "./NotifSearch.vue?vue&type=template&id=128a5cbf&"
import script from "./NotifSearch.vue?vue&type=script&lang=ts&"
export * from "./NotifSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports